module.exports = "/images/vendor/photoswipe/dist/default-skin/preloader.gif?14d740b6ee64510747b03b411d46f200";